type Break = {
  planned_duration: number
}

/**
 * Compute in minute the real break duration for the give break list
 *
 * @param breaks
 *
 * @return number
 */
const getPlannedBreakDuration = <T extends Break>(breaks: T[]): number => {
  return breaks.reduce((time, item) => {
    return time + (item.planned_duration || 0)
  }, 0)
}

export default getPlannedBreakDuration
